
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14.745","height":"10"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"b","transform":"translate(8.463 1.714)"}},[_c('g',{attrs:{"id":"c"}},[_c('g',{attrs:{"id":"Group_29576","data-name":"Group 29576","fill":"none","stroke":"#5a677d","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":".962"}},[_c('path',{attrs:{"id":"d","d":"M8.633 1.493a1.014 1.014 0 010-.179.9.9 0 00-.967-.824H5.75v6.569h1.575","transform":"translate(-2.873 -.485)"}}),_c('path',{attrs:{"id":"e","d":"M1.783 7.054h1.575V.481H1.447a.9.9 0 00-.966.824 1.014 1.014 0 010 .179","transform":"translate(-.481 -.481)"}})])])]),_c('g',{attrs:{"id":"Group_24110","data-name":"Group 24110","transform":"translate(.5 .5)","fill":"none","stroke":"#5a677d","stroke-width":"1"}},[_c('path',{attrs:{"id":"Path_20182","data-name":"Path 20182","d":"M670.561 378.913h2a1.5 1.5 0 011.5 1.5v6a1.5 1.5 0 01-1.5 1.5h-2a1.5 1.5 0 01-1.5-1.5v-6a1.5 1.5 0 011.5-1.5z","transform":"translate(-669.061 -378.913)"}}),_c('g',{attrs:{"id":"Group_23895","data-name":"Group 23895","transform":"translate(0 3.001)"}},[_c('line',{attrs:{"id":"Line_627","data-name":"Line 627","x2":"5"}}),_c('line',{attrs:{"id":"Line_628","data-name":"Line 628","x2":"5","transform":"translate(0 3)"}})])])])
          )
        }
      }
    